import React from 'react';
import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withTranslation } from '@yme/services/i18n';
import ErrorBoundary from '@yme/utils/ErrorBoundary';
import { ProductsGrid } from './ProductsGrid';
import { ProductsGridPagination } from './ProductsGridPagination';
import { isProductsGridEmpty } from './helpers';
const productsGridEditConfig = {
    emptyLabel: 'Products Grid',
    isEmpty: isProductsGridEmpty,
};
function ProductsGridWrapper(props) {
    const ProductsGridComponent = props.isPaginationEnabled ? ProductsGridPagination : ProductsGrid;
    return (React.createElement(ErrorBoundary, null,
        React.createElement(ProductsGridComponent, { ...props })));
}
export default MapTo([
    AEM_FUNCTIONS.clpUnitsGrid,
    AEM_FUNCTIONS.plpAccessoriesGrid,
    AEM_FUNCTIONS.plpClothingMerchGrid,
    AEM_FUNCTIONS.plpUnitsGrid,
])(withTranslation(ProductsGridWrapper), productsGridEditConfig);
